export default __webpack_public_path__ + "static/media/BESS-image-SE.8f3cf6ce.png";